import { useState, useEffect, useRef } from 'react';

/**
 * ResponsiveIframe - Escala un iframe con contenido de dimensiones fijas
 * para que se ajuste al ancho del contenedor manteniendo la proporción.
 */
export const ResponsiveIframe = ({ 
  src, 
  width = 600, 
  height = 150, 
  title = "Content",
  className = "",
  style = {}
}) => {
  const containerRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const updateScale = () => {
      if (containerRef.current) {
        const containerWidth = containerRef.current.offsetWidth;
        setScale(containerWidth / width);
      }
    };

    updateScale();
    window.addEventListener('resize', updateScale);
    return () => window.removeEventListener('resize', updateScale);
  }, [width]);

  const aspectRatio = (height / width) * 100;

  return (
    <div 
      ref={containerRef}
      className={`relative w-full overflow-hidden ${className}`}
      style={{ paddingBottom: `${aspectRatio}%`, ...style }}
    >
      <iframe
        src={src}
        title={title}
        scrolling="no"
        width={width}
        height={height}
        style={{ 
          position: 'absolute',
          top: 0,
          left: 0,
          border: 'none',
          pointerEvents: 'none',
          transform: `scale(${scale})`,
          transformOrigin: 'top left',
        }}
      />
    </div>
  );
};

export default ResponsiveIframe;
